export const routeMap = {
  LANDING_PAGE: "/",
}
